import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getWorkflowStart, removeWorkflowByIdStart } from "../../Store/Slices/workflowSlice";
import { getItem } from "../../Services/localService";
import Loader from "../../Components/Loader";
import DynamicEmailForm from "./template";
import { Utils } from "../../Utils";

const WorkflowRules = () => {
    let navigate = useNavigate();
    let dispatch = useDispatch();
    let basicPermissionData = getItem('modulePermission')?.basic;
    let formList = useSelector((state) => state?.forms);
    let workflowList = useSelector((state) => state?.workflow);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        module: '',
        ruleName: '',
        ruleDescription: ''
    });
    const [moduleList, setModuleList] = useState([]);
    const [selectedId, setSelectedId] = useState('');

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        if (name == 'module') {
            setFormData(prevState => ({ ...prevState, [name]: value.split('#')[0] + '#' + value.split('#')[1] }));
        } else {
            setFormData(prevState => ({ ...prevState, [name]: value }));
        }
    };

    const isFormComplete = formData.module && formData.ruleName;

    useEffect(() => {
        dispatch(getWorkflowStart());
    }, []);

    useEffect(() => {
        if (formList?.navbarList?.length > 0) {
            let list = formList?.navbarList?.filter(x => x.show);
            if (basicPermissionData) {
                list = list.filter(({ _id }) => basicPermissionData?.some(x => (x?.id == _id && x?.activities?.view == true)));
            }
            setModuleList(list);
        }
    }, [formList?.navbarList]);

    useEffect(() => {
        if (workflowList?.reload) {
            setSelectedId('');
            dispatch(getWorkflowStart());
        }
    }, [workflowList?.reload]);

    const removeWorkflow = (id) => {
        dispatch(removeWorkflowByIdStart(id));
    }

    // const removeData = (subModuleId) => {
    //     dispatch(removeSubFormByIdStart(subModuleId));
    // }
    const editHandler = (id, list) => {
        navigate(Utils.getNavigationUrl(`workflow-rules/edit/${id}`), { state: list })
    }

    //   UI
    return (
        <React.Fragment>
            {/* <DynamicEmailForm /> */}
            <Loader isVisible={workflowList?.isLoading} />
            {/* <div className="main-panel">
                <main className="py-md-4 content-section">
                    <div className="container-fluid"> */}
            <div className="card rounded-4 border-0">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12 setup-actions d-flex pb-4 pt-0">
                            <div className="left d-flex align-items-start">
                                <div className="search-box border rounded-pill">
                                    <button className="searchbutton bg-white" type="button"><i className="fa-solid fa-magnifying-glass"></i></button>
                                    <input type="search" placeholder="Search" className="searchfield bg-white" />
                                </div>
                            </div>
                            <div className="ms-auto">
                                <div className="btn-group">
                                    <button type="button" className="btn btn-light rounded-pill py-1 px-3 flat-btn">Reorder Rules</button>
                                    <button type="button" className="btn btn-primary rounded-pill btn-blue" onClick={handleShow}>
                                        <i className="fa-solid fa-plus me-2"></i>
                                        <span>New Rule</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <Modal
                            show={show}
                            onHide={handleClose}
                            backdrop="static"
                            keyboard={false}
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>Create New Rule</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                        <Form.Label>Module</Form.Label>
                                        <Form.Select name={'module'}
                                            required
                                            value={formData.module}
                                            onChange={handleInputChange} >
                                            <option value="" disabled selected>Select</option>
                                            {moduleList && moduleList.length > 0 ? (
                                                moduleList.map((module) => (
                                                    <option value={module._id + '#' + module.name}>{module.name}</option>
                                                ))
                                            ) : null}
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Rule Name</Form.Label>
                                        <Form.Control
                                            value={formData.ruleName}
                                            onChange={handleInputChange}
                                            type={'text'}
                                            name={'ruleName'}
                                            required
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Description</Form.Label>
                                        <Form.Control as="textarea" rows={1}
                                            value={formData.ruleDescription}
                                            onChange={handleInputChange}
                                            type={'text'}
                                            name={'ruleDescription'}
                                        // required
                                        />
                                    </Form.Group>
                                </Form>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleClose}>
                                    Cancel
                                </Button>
                                <Button variant="primary" disabled={!isFormComplete}
                                    onClick={() => navigate(Utils.getNavigationUrl("workflow-rules/create"), { state: formData })}
                                >Next</Button>
                            </Modal.Footer>
                        </Modal>

                        <div className="col-md-12">
                            <div className="tbl-container rounded-table">
                                <div className="table-responsive">
                                    <table className="table mb-0">
                                        <thead>
                                            <tr>
                                                <th>Rule Name</th>
                                                <th>All Modules</th>
                                                <th>Execute On</th>
                                                <th>Last Modified</th>
                                                <th>Update</th>
                                                <th>Remove</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {workflowList?.data && workflowList?.data.length > 0 ? (
                                                workflowList?.data.map((list) => (
                                                    <tr key={list?._id}>
                                                        <td>{list?.ruleName}</td>
                                                        <td>{list?.moduleId?.name}</td>
                                                        <td>{list?.rules?.workflow_base_type}</td>
                                                        <td>{new Date(list?.updatedAt).toLocaleDateString()}</td>
                                                        <td>
                                                            {/* <button
                                                                type="button"
                                                                className="btn btn-primary rounded-pill"
                                                                onClick={() => editHandler(list?._id)}
                                                            // onClick={() => navigate(`/form-module/sub-form/update/${id}/${formsubmodules?.formsubmodules?.[index]?._id}`)}
                                                            >
                                                                Edit
                                                            </button> */}
                                                            <span style={{ color: "#29409d" }} className="cursor-pointer"
                                                                onClick={() => editHandler(list?._id, list)}>
                                                                <i className="fas fa-edit"></i>
                                                            </span>
                                                        </td>
                                                        <td>
                                                            {/* <button
                                                                type="button"
                                                                className="btn btn-danger rounded-pill"
                                                                onClick={() => removeWorkflow(list?._id)}
                                                            >
                                                                Remove
                                                            </button> */}
                                                            <span style={{ color: "#dc3545" }} className="cursor-pointer"
                                                                // onClick={() => removeWorkflow(list?._id)}
                                                                onClick={() => setSelectedId(list?._id)}
                                                                data-bs-toggle="modal" data-bs-target="#deleteAlertModal"
                                                            >
                                                                <i className="fas fa-trash"></i>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="6" className="text-center">No workflow rules found</td>
                                                </tr>
                                            )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* </div>
                </main>
            </div> */}
            {/* Delete confirmation modal*/}
            <div className="modal fade" id="deleteAlertModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="curDeactivateAlertLabel" aria-hidden="true">
                <div className="modal-dialog alert-modal">
                    <div className="modal-content">
                        <div className="modal-body">
                            <h4 className='pb-3'>Delete Workflow Rule</h4>
                            <p className='fw-semibold'>
                                Are you sure you want to delete this workflow rule?
                            </p>
                        </div>
                        <div className="modal-footer border-top-0">
                            <button type="button" className="btn btn-outline-secondary rounded-pill flat-btn text-secondary"
                                onClick={() => { setSelectedId('') }}
                                data-bs-dismiss="modal">Cancel</button>
                            <button type="button" className="btn btn-danger rounded-pill btn-blue" data-bs-dismiss="modal"
                                onClick={() => removeWorkflow(selectedId)}
                            >
                                Yes, Delete
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {/* Delete confirmation modal */}
        </React.Fragment>
    )
}
export default WorkflowRules;